var _line, _line2, _circle, _path, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionareCuMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 34,
    x2: 27,
    y2: 34,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 34,
    x2: 39,
    y2: 34,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 34,
    r: 9,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8608 29.2727H7.79545L10.3864 35.5966H10.4886L13.0795 29.2727H15.0142V38H13.4972V32.0043H13.4162L11.0043 37.9744H9.87074L7.45881 31.9915H7.37784V38H5.8608V29.2727Z",
    fill: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 34,
    x2: 51,
    y2: 34,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionareCuMotor);
export default __webpack_public_path__ + "static/media/actionare_cu_motor.8d71310d72646ac9e985bf8c7b375ab2.svg";
export { ForwardRef as ReactComponent };